import React, { useContext, useState } from 'react';
import { Alert, Box, Button, Checkbox, CircularProgress, DialogContent, TextField, Typography } from '@mui/material';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import CustomDialog from '../custom-dialog/custom-dialog';
import PasswordField from '../password-field/password-field';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { useSnackBar } from '../../../contexts/snackbar';

interface UndoDeliveryDialogProps {
  open: boolean;
  onClose: () => void;
  order?: OrderType;
  onSuccess: () => void;
}

const UndoDeliveryDialog: React.FC<UndoDeliveryDialogProps> = ({
                                                                 open,
                                                                 onClose,
                                                                 order,
                                                                 onSuccess,
                                                               }) => {

  const [understandConsequences, setUnderstandConsequences] = useState(false);
  const [undoDeliveryPassword, setUndoDeliveryPassword] = useState('');
  const [undoDeliveryLoading, setUndoDeliveryLoading] = useState(false);
  const [undoDeliveryError, setUndoDeliveryError] = useState<string | null>(null);
  const {config} = useContext(AuthContext);
  const {showMessage} = useSnackBar();


  const handleUndoDelivery = async () => {
    if (!order) return;
    setUndoDeliveryLoading(true);
    setUndoDeliveryError(null);
    try {
      const response = await axios.put(
        `${API_ENDPOINT}/api/v1/order/${order.id}/undo-delivery/`,
        { password: undoDeliveryPassword },
        config,
      );
      showMessage('Delivery undone successfully');
      onSuccess();
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setUndoDeliveryError(e.response?.data?.detail || 'Failed to undo delivery');
      } else {
        setUndoDeliveryError('Failed to undo delivery');
      }
    }
    setUndoDeliveryLoading(false);
  };

  return    <CustomDialog fullWidth open={open} onClose={onClose}>
    <DialogContent sx={{ px: 3, py: 2 }}>
      <Typography variant="h5" component="h5" sx={{ mb: 1 }}>
        Confirm Undo Delivery
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Please Enter your password to confirm undoing the delivery.
      </Alert>
      {(order?.driver_invoice || order?.merchant_invoice) && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Warning: This will remove the order from the following invoices:
          <ul>

            {order?.last_delivery_task?.driver_invoice && <li> {order?.last_delivery_task?.driver_invoice.purpose.toLowerCase()} driver invoice #{order?.last_delivery_task?.driver_invoice.id}</li>}
            {order?.last_delivery_task?.commission_invoice && <li> {order?.last_delivery_task?.commission_invoice?.purpose.toLowerCase()} driver invoice #{order.last_delivery_task.commission_invoice.id}</li>}
            {order?.merchant_invoice && <li> merchant invoice #{order.merchant_invoice.id}</li>}
          </ul>
          
          <Checkbox checked={understandConsequences} onChange={(e) => setUnderstandConsequences(e.target.checked)} /><b>I understand the consequences of undoing the delivery.</b>
        </Alert>
      )}
      <Box sx={{ mb: 2 }}>
          <PasswordField
            label="Password "
            placeholder={'Enter your password to proceed'}
            value={undoDeliveryPassword}
            onPasswordChange={(value) =>
              setUndoDeliveryPassword(value)
            }
            variant="outlined"
          />
       
      </Box>
      {undoDeliveryError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {undoDeliveryError}
        </Alert>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
        <Button onClick={onClose} disabled={undoDeliveryLoading} variant="outlined">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleUndoDelivery}
          disabled={undoDeliveryPassword.length === 0 || undoDeliveryLoading || (!understandConsequences && (order?.driver_invoice != undefined || order?.merchant_invoice != undefined))}
        >
          {undoDeliveryLoading ? <CircularProgress size={24} /> : 'Confirm'}
        </Button>
      </Box>
    </DialogContent>
  </CustomDialog>                                                                
                                                               }
 


export default UndoDeliveryDialog;